module.exports = __webpack_public_path__ + "static/media/inx_facebook.79482fb4.svg";